<template>
    <div id="mobileOverlay" class="tasks-list-wrapper">
        <div class="card-box">
            <b-card
                    no-body
                    tag="article"
                    class="test-card empty"
                    w-100>
                <b-card-body>
                    <em class="icon-alert"></em>
                    <h2>{{$t('general.mobile_overlay.title')}}</h2>
                    <b-card-text>{{$t('general.mobile_overlay.message')}}</b-card-text>
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'mobile-overlay'
    }
</script>
